import { Image } from "antd";
import imgLogo from "assets/images/logo.jpeg";

export const Logo = () => {
	return <Image width={80} src={imgLogo} preview={false} />;
};
